"use strict";
//var $ = require('jquery');
//var validation = require('jquery-validation');
//var unobtrusiveValidation = require('jquery-validation-unobtrusive');
//var gritter = require('gritter');
//var ladda = require('ladda');
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jquery_1 = __importDefault(require("jquery"));
require("jquery-validation");
require("jquery-validation-unobtrusive");
// globally handle exceptions from ajax calls
(0, jquery_1.default)(document)
    .ajaxError(function (event, request, settings, exception) {
    //ladda.stopAll();
    if (request.status === 401) {
        window.location.href = '/account/login';
    }
    if (request.responseText === "")
        return;
    var data = jquery_1.default.parseJSON(request.responseText); // parse the response into a JavaScript object
    var error = '';
    var focusOnId = '';
    if (!jquery_1.default.isEmptyObject(data.Errors)) {
        var index = 0;
        for (var prop in data.Errors) {
            // important check that this is objects own property 
            // not from prototype prop inherited
            if (data.Errors.hasOwnProperty(prop)) {
                if (index === 0)
                    focusOnId = prop;
                error += data.Errors[prop] + "<br />";
                index++;
            }
        }
    }
    else if (!jquery_1.default.isEmptyObject(data.modelState)) {
        var index = 0;
        for (var prop in data.modelState) {
            if (data.modelState.hasOwnProperty(prop)) {
                var errors = data.modelState[prop].Errors;
                for (var prop2 in errors) {
                    if (errors.hasOwnProperty(prop2)) {
                        error += data.modelState[prop].Errors[prop2] + "<br />";
                    }
                }
            }
            index++;
        }
    }
    else {
        // for cases where model state errors are returned from api controllers.
        if (!jquery_1.default.isEmptyObject(data.ModelState)) {
            for (var prop in data.ModelState) {
                // important check that this is objects own property 
                // not from prototype prop inherited
                if (data.ModelState.hasOwnProperty(prop)) {
                    error += data.ModelState[prop] + "<br />";
                }
            }
        }
        else if (data.ExceptionMessage) {
            error = data.ExceptionMessage;
            //} else if (data.Message) {
            //    error = data.Message;
            //    // cases where a message/exceptionMessage is passed
        }
        else if (!jquery_1.default.isEmptyObject(data)) {
            var index = 0;
            // THIS IS JUST A STOP GAP UNTIL CLIENT SIDE VALIDATION IS WORKING FOR FLUENT VALIDATION IN .NET CORE
            // clear out any errors we displayed previously - they may have turned valid now
            (0, jquery_1.default)(".invalid").removeClass('invalid');
            (0, jquery_1.default)('.field-validation-invalid').removeClass('field-validation-invalid').html('');
            for (var prop in data) {
                if (prop === '') {
                    error += "<li>" + data[prop][0] + "</li>";
                }
                else {
                    if (index === 0)
                        focusOnId = prop;
                    // important check that this is objects own property 
                    // not from prototype prop inherited
                    if (data.hasOwnProperty(prop)) {
                        (0, jquery_1.default)("#" + prop).addClass('is-invalid').removeClass('is-valid');
                        (0, jquery_1.default)('[data-valmsg-for="' + prop + '"]')
                            .removeClass('field-validation-valid')
                            .addClass('field-validation-invalid')
                            .html(data[prop][0]);
                        error += data[prop][0] + "<br /><br />";
                    }
                    index++;
                }
            }
            if (focusOnId !== '') {
                (0, jquery_1.default)("#" + focusOnId).focus();
            }
            else {
                (0, jquery_1.default)('html, body').animate({ scrollTop: 0 }, 'slow');
            }
        }
    }
    if (error !== '') {
        (0, jquery_1.default)(".display-errors").html(error);
        // show the error
        //$.gritter.add({
        //    title: 'Error',
        //    text: error,
        //    class_name: 'gritter-error'
        //});
        if (focusOnId !== '') {
            (0, jquery_1.default)("#" + focusOnId).focus();
        }
        else {
            (0, jquery_1.default)('html, body').animate({ scrollTop: 0 }, 'slow');
        }
    }
    // reset any buttons so they can try and re-submit after correcting forms
    //ladda.stopAll();
});
